import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
export class CanActivateLivePageGuard {
    constructor() {
    }
    canActivate(route, state) {
        if (environment.rallyPageEnabled) {
            return true;
        }
        else {
            const redirectURL = environment.production ? environment.corporateUrl : window.location.origin;
            window.location.href = redirectURL;
        }
        return false;
    }
}
CanActivateLivePageGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanActivateLivePageGuard_Factory() { return new CanActivateLivePageGuard(); }, token: CanActivateLivePageGuard, providedIn: "root" });
